import React from 'react';
import { ThumbsUp, ThumbsDown } from 'lucide-react';

/**
 * ActionButtons Component
 * - Displays Accept/Reject buttons for AI-suggested text changes
 * - Only appears when there is pending AI-suggested text
 * - Aligned to the right of the editor
 */
const ActionButtons = ({ onAccept, onReject, isLoading }) => {
  return (
    <div className="ai-actions-container mt-2">
      <button
        className="btn btn-sm btn-secondary ai-action-button"
        onClick={onReject}
        disabled={isLoading}
        title="Rechazar cambios"
      >
        <ThumbsDown size={16} />
        <span>Rechazar</span>
      </button>
      <button
        className="btn btn-sm btn-primary ai-action-button"
        onClick={onAccept}
        disabled={isLoading}
        title="Aceptar cambios"
      >
        <ThumbsUp size={16} />
        <span>Aceptar</span>
      </button>
    </div>
  );
};

ActionButtons.defaultProps = {
  isLoading: false
};

export default ActionButtons;
